import { Component, OnInit, ViewChild } from '@angular/core';
import { getCompOptionsByType, _MSGTYPES } from '../../shared/constant/msgType';
import { DialogService, IccMsgGeneratorComponent, MessageService, PermissionControlService } from 'mmmo-mo-common-lib';
import { MsgEditor } from '../../msg-interface/msg-editor';
import { VoiceTplAutoMatchComponent } from '../voice-tpl-auto-match/voice-tpl-auto-match.component';

@Component({
  selector: 'icc-voice-editor',
  templateUrl: './voice-editor.component.html',
  styles: [],
})
export class VoiceEditorComponent implements OnInit, MsgEditor {
  constructor(private permissionControl: PermissionControlService, private dialogService: DialogService, private messageService: MessageService) {}
  @ViewChild('msgtplgenerator', { static: false }) tplGenerator: IccMsgGeneratorComponent;
  @ViewChild('msgtplcomp', { static: false }) msgTplComp: VoiceTplAutoMatchComponent;
  SCENE = 'icc-msg-editor';
  type = _MSGTYPES.MT.VOICE.type;
  // 是否自动匹配
  isAutoMath: boolean;
  // 自动匹配列表数据
  tplList: Array<any>;
  options = [
    {
      form: [
        {
          type: 'textarea',
          require: true,
          maxlength: 500,
          placeholder: '请输入语音内容',
          disabled: true,
          config: {
            value: '',
            isHasTemplate: false,
            isHasPaster: false, // 贴片
            pasterList: [],
            pasterClick: () => {
              // console.log('aaa');
            }, // 贴片事件
          },
        },
      ],
    },
  ];
  // 【选择模板】模板id
  templateId: string;

  ngOnInit() {
    // const textAreaComp = this.getTextAreaComp();
    // textAreaComp.config.isHasPaster = !this.permissionControl.getLimitByField('patch');
  }
  /* 设置禁用状态 */
  setDisabled(disabled: boolean): void {
    const textAreaComp = this.getTextAreaComp();
    // 语音始终为禁用
    textAreaComp.disabled = true;
  }
  /* 数据重置 */
  resetData() {
    const textAreaComp = this.getTextAreaComp();
    textAreaComp.config.value = '';
    textAreaComp.config.pasterList = [];
    this.templateId = '';
    this.cancelAutoMathTpl();
  }
  /* 数据校验 */
  validate(): boolean {
    if (this.isAutoMath || this.templateId) return true;
    const textAreaComp = this.getTextAreaComp();
    const hasContent = textAreaComp.config.value;
    if (!hasContent) {
      this.dialogService.notification.warning('提示', '语音内容不能为空');
    }
    return hasContent;
  }
  /* 选择模板数据设置 */
  setSelectedTplData(tplData: any) {
    if (!tplData) return;
    const textAreaComp = this.getTextAreaComp();
    textAreaComp.config.pasterList = tplData.patchInfos;
    textAreaComp.config.value = tplData.content;
    this.templateId = tplData.templateId;
  }
  /* 自动匹配模板设置 */
  setAutoMathTpl(tplList: Array<any>): void {
    this.isAutoMath = true;
    this.tplList = tplList;
  }
  /* 自动匹配模板取消 */
  cancelAutoMathTpl(): void {
    this.isAutoMath = false;
    this.tplList = [];
  }
  /* 获取数据 */
  getMessageData() {
    const textAreaComp = this.getTextAreaComp();
    let message: any = {};
    if (this.templateId) {
      message = {
        msgType: this.type,
        templateId: this.templateId,
      };
    } else {
      message = {
        msgType: this.type,
        content: textAreaComp.config.value,
        patchInfos: textAreaComp.config.pasterList,
      };
      if (message.patchInfos && message.content) {
        const templateContent = message.content;
        message.patchInfos = message.patchInfos.filter(ps => templateContent.indexOf('${' + ps.groupName + '}') !== -1);
      }
    }

    return message;
  }
  /* 获取移动端预览数据 */
  getMobilePreviewData() {
    const previewData = {
      name: '语音',
      msgType: this.type,
      structureType: 0,
      sender: '98XXX',
      date: '2月26日',
      week: '周二',
      time: '12:26',
      infos: [],
    };
    let content = '';
    if (this.isAutoMath) {
      if (this.msgTplComp.viewList && this.msgTplComp.viewList.length > 0) {
        content = this.msgTplComp.viewList[0].content;
      } else {
        content = '';
      }
    } else {
      const textAreaComp = this.getTextAreaComp();
      content = textAreaComp.config.value;
    }
    previewData.infos.push({
      content,
    });
    return previewData;
  }
  /* 获取textarea */
  getTextAreaComp() {
    return this.messageService.getCompOptionsByType(this.options, 'textarea')[0];
  }
}
